export default __webpack_public_path__ + "static/media/approved.cb751670.png";